import React from 'react';
import PropTypes from 'prop-types';

import { MediaWrapper } from './styles';

const NFTVideo = ({ urlMetadata, progress }) => (
  <MediaWrapper opacity={1 - progress / 100}>
    <video controlsList="nodownload nofullscreen noremoteplayback" controls muted autoPlay loop playsInline disablePictureInPicture preload="auto">
      <source src={urlMetadata} type="video/mp4" />
    </video>
  </MediaWrapper>
);

NFTVideo.defaultProps = {
  progress: 0,
};

NFTVideo.propTypes = {
  progress: PropTypes.number,
  urlMetadata: PropTypes.string.isRequired,
};
export default NFTVideo;
